import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

/**
 * Creates a saga middleware instance.
 * @returns The created saga middleware instance.
 */
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * Creates a Redux store with the specified root reducer and middleware.
 * @param {Function} rootReducer - The root reducer function that combines all reducers.
 * @param {Function} composeEnhancers - The function that enhances the store with additional capabilities.
 * @param {Function} applyMiddleware - The function that applies middleware to the store.
 * @param {Object} sagaMiddleware - The middleware for handling asynchronous actions with Redux Saga.
 * @returns {Object} - The created Redux store.
 */
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

export default store;
